import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledContainer = styled.div``;

export const StyledNearAmount = styled.p`
  &:not(:last-child) {
    margin-bottom: 3px;
  }
`;

export const StyledFiatAmount = styled.span`
  font-size: ${themeGet('fontSizes.xs')}px;
`;

export const StyledDots = styled.div`
  color: ${themeGet('colors.text.default')};

  &:after {
    content: '.';
    animation: link 1s steps(5, end) infinite;

    @keyframes link {
      0%,
      20% {
        color: rgba(0, 0, 0, 0);
        text-shadow: 0.3em 0 0 rgba(0, 0, 0, 0), 0.6em 0 0 rgba(0, 0, 0, 0);
      }
      40% {
        color: #4a4f54;
        text-shadow: 0.3em 0 0 rgba(0, 0, 0, 0), 0.6em 0 0 rgba(0, 0, 0, 0);
      }
      60% {
        text-shadow: 0.3em 0 0 #4a4f54, 0.6em 0 0 rgba(0, 0, 0, 0);
      }
      80%,
      100% {
        text-shadow: 0.3em 0 0 #4a4f54, 0.6em 0 0 #4a4f54;
      }
    }
  }
`;
